/* eslint-disable no-unused-vars */
import { Amplify, I18n } from "aws-amplify";
import { translations } from "@aws-amplify/ui-react";

import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AwsRum } from "aws-rum-web";

import awsExports from "./aws-exports";
import Store from "./modules/store/Store";
import Messages from "./modules/messages/Messages";
import AdminLayout from "layout/AdminLayout";
import { Devices } from "./modules/devices";
import { Companies } from "modules/companies";
import { Branches } from "modules/branches";
import { Roles } from "modules/roles";
import { AlertsTab } from "modules/alerts";
import { RulesTab } from "modules/rules";
import { Variables } from "modules/variables";
import { Actions } from "modules/actions";
import { CostCenters } from "modules/costCenters";
import { Holidays } from "modules/holidays";
import { Users } from "modules/users";
import { Monitor } from "modules/monitor";
import { DashboardTab } from "modules/dashboard";
import { Parameters } from "modules/parameters";
import { Equipments } from "modules/equipments";
import { EquipmentTypes } from "modules/equipmentTypes";
import { ServiceOrders } from "modules/serviceOrders";
import { MaintenanceSchedules } from "modules/maintenanceSchedules";
import { Tools } from "modules/tools";
import { Spares } from "modules/spares";
import { MaintenanceRoutines } from "modules/maintenanceRoutines";
import PayrollReport from "modules/payrollReport/PayrollReport";
import ProtectedComponent from "components/ProtectedComponent";

import Diagrams from "./modules/diagrams/Diagrams";
import MaintenanceDashboard from "./modules/maintenanceDashboard/MaintenanceDashboard";
import MaintenanceRequirement from "./modules/maintenanceRequiaraement/MaintenanceRequirement";
import IncomesAndExpenses from "./modules/incomesAndExpenses/IncomesAndExpenses";
import FailureAnalytics from "./modules/failureAnalytics/FailureAnalytics";
import Reports from "./modules/reports/Reports";
import Forecast from "./modules/forecast/Forecast";
import DataExporter from "./modules/dataExporter/DataExporter";
import WorkRoutines from "./modules/workRoutines/WorkRoutines";
import Groups from "./modules/groups/Groups";
import PermissionsRequired from "components/PermissionsRequired";

import AgroRoutes from "routes/agro-routes";

import "@aws-amplify/ui-react/styles.css";
import "@coreui/coreui/dist/css/coreui.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "tippy.js/dist/tippy.css";
import ExportServiceOrder from "modules/serviceOrders/ExportServiceOrder";

I18n.putVocabularies(translations);
I18n.setLanguage("es");

I18n.putVocabularies({
  es: {
    "Account recovery requires verified contact information":
      "La recuperación de la cuenta requiere información de contacto verificada",
    "Add your Profile": "Agrega tu perfil",
    "Add your Website": "Agrega tu sitio web",
    "Back to Sign In": "Volver a Iniciar Sesión",
    "Change Password": "Cambiar Contraseña",
    Changing: "Cambiando",
    Code: "Código",
    "Confirm Password": "Confirmar contraseña",
    "Confirm Sign Up": "Confirmar Registro",
    "Confirm SMS Code": "Confirmar Código SMS",
    "Confirm MFA Code": "Confirmar Código MFA",
    "Confirm TOTP Code": "Confirmar Código TOTP",
    Confirm: "Confirmar",
    "Confirmation Code": "Código de Confirmación",
    Confirming: "Confirmando",
    "Create a new account": "Crear una nueva cuenta",
    "Create Account": "Crear Cuenta",
    "Creating Account": "Creando Cuenta",
    "Dismiss alert": "Descartar alerta",
    Email: "Correo Electrónico",
    "Enter your Birthdate": "Ingresa tu Fecha de Nacimiento",
    "Enter your code": "Ingresa tu código",
    "Enter your Confirmation Code": "Ingresa tu Código de Confirmación",
    "Enter your Email": "Ingresa tu Correo Electrónico",
    "Enter your Family Name": "Ingresa tu Apellido",
    "Enter your Given Name": "Ingresa tu Nombre",
    "Enter your Middle Name": "Ingresa tu Segundo Nombre",
    "Enter your Name": "Ingresa tu Nombre",
    "Enter your Nickname": "Ingresa tu Apodo",
    "Enter your Password": "Ingresa tu Contraseña",
    "Enter your phone number": "Ingresa tu número de teléfono",
    "Enter your Preferred Username": "Ingresa tu Nombre de Usuario Preferido",
    "Enter your username": "Ingresa tu nombre de usuario",
    "Forgot password?": "¿Olvidaste tu contraseña?",
    "Forgot your password?": "¿Olvidaste tu contraseña?",
    "Hide password": "Ocultar contraseña",
    "It may take a minute to arrive": "Puede tardar un minuto en llegar",
    Loading: "Cargando",
    "Current Password": "Contraseña actual",
    "New password": "Nueva contraseña",
    "Update password": "Actualizar contraseña",
    "Password must have at least 8 characters":
      "La contraseña debe tener al menos 8 caracteres",
    "Password must have upper case letters":
      "La contraseña debe tener letras en mayúscula",
    "Password must have lower case letters":
      "La contraseña debe tener letras en minúscula",
    "Password must have numbers": "La contraseña debe tener números",
    "Password must have special characters":
      "La contraseña debe tener caracteres especiales",
    "Incorrect username or password": "Usuario o contraseña incorrectos.",
    or: "o",
    Password: "Contraseña",
    "Phone Number": "Número de Teléfono",
    "Please confirm your Password": "Por favor confirma tu Contraseña",
    "Resend Code": "Reenviar Código",
    "Reset your password": "Restablecer tu contraseña",
    "Reset your Password": "Restablecer tu Contraseña",
    "Send code": "Enviar código",
    "Send Code": "Enviar Código",
    "Reset Password": "Restablecer tu Contraseña",
    Sending: "Enviando",
    "Setup TOTP": "Configurar TOTP",
    "Show password": "Mostrar contraseña",
    "Sign in to your account": "Inicia sesión en tu cuenta",
    "Sign In with Amazon": "Iniciar Sesión con Amazon",
    "Sign In with Apple": "Iniciar Sesión con Apple",
    "Sign In with Facebook": "Iniciar Sesión con Facebook",
    "Sign In with Google": "Iniciar Sesión con Google",
    "Sign in": "Iniciar sesión",
    "Sign In": "Iniciar Sesión",
    "Signing in": "Iniciando sesión",
    Skip: "Omitir",
    Submit: "Enviar",
    Submitting: "Enviando",
    Username: "Nombre de Usuario",
    "Verify Contact": "Verificar Contacto",
    "Enter your Username": "Ingresa tu nombre de usuario",
    Name: "Nombre",
    Verify: "Verificar",
    "We Emailed You": "Te Hemos Enviado un Correo Electrónico",
    "We Sent A Code": "Te Hemos Enviado un Código",
    "We Texted You": "Te Hemos Enviado un Mensaje de Texto",
    "Your code is on the way. To log in, enter the code we emailed to":
      "Tu código está en camino. Para iniciar sesión, ingresa el código que enviamos a",
    "Your code is on the way. To log in, enter the code we sent you":
      "Tu código está en camino. Para iniciar sesión, ingresa el código que te enviamos",
    "Your code is on the way. To log in, enter the code we texted to":
      "Tu código está en camino. Para iniciar sesión, ingresa el código que te enviamos por mensaje de texto",
    "PreSignUp failed with error El usuario ya existe.":
      "El usuario ya existe.",
  },
});

try {
  const config = {
    sessionSampleRate: 1,
    guestRoleArn:
      "arn:aws:iam::844304051683:role/RUM-Monitor-us-east-1-844304051683-2601334499071-Unauth",
    identityPoolId: "us-east-1:ab6cddff-2d6c-454c-ac86-1be5a9f09495",
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: true,
  };

  const APPLICATION_ID = "bf66345f-2725-4948-b0bc-7b2a416c3e80";
  const APPLICATION_VERSION = "1.0.0";
  const APPLICATION_REGION = "us-east-1";

  new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

awsExports.oauth.domain = "auth.cimaiot.com"
Amplify.configure(awsExports);

const App = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="store">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Store />}
                permission="store:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="messages">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Messages />}
                permission="message:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="devices">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Devices />}
                permission="device:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="diagrams">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Diagrams />}
                permission="diagram:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="monitor">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Monitor />}
                permission="monitor:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="dashboard">
          <Route
            index
            element={
              <ProtectedComponent
                component={<DashboardTab />}
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="alerts">
          <Route
            index
            element={
              <ProtectedComponent component={<AlertsTab />} redirectTo={`/`} />
            }
          />
        </Route>
        <Route path="rules">
          <Route
            index
            element={
              <ProtectedComponent component={<RulesTab />} redirectTo={`/`} />
            }
          />
        </Route>
        <Route path="maintenance-dashboard">
          <Route
            index
            element={
              <ProtectedComponent
                component={<MaintenanceDashboard />}
                permission="maintenance-dashboard:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="equipment-types">
          <Route
            index
            element={
              <ProtectedComponent
                component={<EquipmentTypes />}
                permission="equipment-type:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="equipments">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Equipments />}
                permission="equipment:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="maintenance-requirement">
          <Route
            index
            element={
              <ProtectedComponent
                component={<MaintenanceRequirement />}
                permission="maintenance-requirement:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="service-orders">
          <Route
            index
            element={
              <ProtectedComponent
                component={<ServiceOrders />}
                permission="service-order:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="maintenance-schedules">
          <Route
            index
            element={
              <ProtectedComponent
                component={<MaintenanceSchedules />}
                permission="maintenance-schedule:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="tools">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Tools />}
                permission="tool:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="spares">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Spares />}
                permission="spare:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="maintenance-routines">
          <Route
            index
            element={
              <ProtectedComponent
                component={<MaintenanceRoutines />}
                permission="maintenance-routine:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="payroll-report">
          <Route
            index
            element={
              <ProtectedComponent
                component={<PayrollReport />}
                permission="payroll-report:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="export-service-orders">
          <Route
            index
            element={
              <ProtectedComponent
                component={<ExportServiceOrder />}
                permission="service-order:export"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="incomes-and-expenses">
          <Route
            index
            element={
              <ProtectedComponent
                component={<IncomesAndExpenses />}
                permission="income-and-expense:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="failure-analytics">
          <Route
            index
            element={
              <ProtectedComponent
                component={<FailureAnalytics />}
                permission="failure-analytic:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="reports">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Reports />}
                permission="report:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="forecast">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Forecast />}
                permission="forecast:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="data-exporter">
          <Route
            index
            element={
              <ProtectedComponent
                component={<DataExporter />}
                permission="data-exporter:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="companies">
          <Route
            path=""
            element={
              <ProtectedComponent
                component={<Companies />}
                permission="company:read"
                redirectTo="/"
              />
            }
          >
            <Route
              path=":companyId/details"
              element={
                <ProtectedComponent
                  component={<Branches />}
                  permission="company-branch:read"
                  redirectTo="/companies"
                />
              }
            />
          </Route>
        </Route>
        <Route path="parameters">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Parameters />}
                permission="parameter:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="work-routines">
          <Route
            index
            element={
              <ProtectedComponent
                component={<WorkRoutines />}
                permission="work-routine:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="variables">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Variables />}
                permission="variable:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="actions">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Actions />}
                permission="action:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="cost-centers">
          <Route
            index
            element={
              <ProtectedComponent
                component={<CostCenters />}
                permission="cost-center:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="holidays">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Holidays />}
                permission="holiday:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="roles">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Roles />}
                permission="role:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="groups">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Groups />}
                permission="group:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route path="users">
          <Route
            index
            element={
              <ProtectedComponent
                component={<Users />}
                permission="user:read"
                redirectTo={`/`}
              />
            }
          />
        </Route>
        <Route
          path="agro/*"
          element={
            <ProtectedComponent
              component={<AgroRoutes />}
              permission="agro:read"
              redirectTo={`/`}
            />
          }
        />
        <Route path="/" element={<Navigate to="/monitor" />} />
        <Route path="permissions-required" element={<PermissionsRequired />} />
        <Route path="*" element={<h1>Not Found</h1>} />
      </Routes>
    </AdminLayout>
  );
};

export default App;
